import React from 'react';
import { useTranslation } from "react-i18next";

function AlakolSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("alakol.title", "Alakol Lake")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "alakol.intro",
                    "Alakol Lake, located on the border of Almaty and East Kazakhstan regions, is a large salt lake famous for its healing mineral waters and unique biodiversity. The lake’s name means 'multicolored lake', reflecting its shimmering hues under different light conditions."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("alakol.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("alakol.highlight1", "Therapeutic mineral-rich waters believed to aid health and recovery.")}</li>
                <li>{t("alakol.highlight2", "Important stop for migratory birds, including rare species like flamingos and pelicans.")}</li>
                <li>{t("alakol.highlight3", "Picturesque beaches and growing tourism infrastructure along the lakeshore.")}</li>
                <li>{t("alakol.highlight4", "Part of the Alakol Biosphere Reserve, recognized by UNESCO for its ecological value.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "alakol.conclusion",
                    "Alakol Lake combines natural beauty, health benefits, and ecological importance, making it one of the most attractive destinations in Kazakhstan for both relaxation and nature exploration."
                )}
            </p>
        </div>
    );
}

export default AlakolSightPage;
